import ModemDetailsContainer from '../../../../components/units/Management/Modem/details/modemDetailsContainer';

export default function ModemDetailsPage() {
  return <ModemDetailsContainer />;
}
